import React from 'react';
import { BarChartOutlined } from '@ant-design/icons';

const ChartEmptyState = ({ minHeight = 280 }) => {
  return (
    <div
      className="flex items-center justify-center w-full rounded-xl border border-dashed border-slate-200 dark:border-slate-600 bg-gradient-to-b from-slate-50/90 to-slate-100/40 dark:from-slate-800/50 dark:to-slate-900/30 px-6 py-10"
      style={{ minHeight }}
    >
      <div className="flex flex-col items-center justify-center text-center max-w-sm mx-auto gap-3">
        <div className="w-14 h-14 rounded-2xl bg-indigo-50 dark:bg-indigo-950/50 flex items-center justify-center text-indigo-500 shadow-inner border border-indigo-100/80 dark:border-indigo-800/60">
          <BarChartOutlined className="text-2xl" />
        </div>
        <p className="m-0 text-slate-600 dark:text-slate-300 custom-font text-sm sm:text-base leading-relaxed font-medium">
          داده‌ای برای نمودار وجود ندارد
        </p>
        <p className="m-0 text-slate-400 dark:text-slate-500 custom-font text-xs">
          بازه یا فیلترها را تغییر دهید
        </p>
      </div>
    </div>
  );
};

export default ChartEmptyState;
